(function (_$, Cookies) {
    const cookieSet = Cookies.set;
    const cookieGet = Cookies.get;

    function splashScreen() {
        cookieSet('SplashScreenVisited', 'Yes', { expires: 30 });
        if (cookieGet('SplashScreenVisited') === 'Yes') {
            document.getElementById('app-overlay').style.display = 'none';
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        if (cookieGet('SplashScreenVisited') !== 'Yes') {
            document.getElementById('app-overlay').style.display = 'block';
        }
    });

    if (document.querySelector('#close-btn') !== null) {
        document.querySelector('#close-btn').addEventListener('click', function () {
            splashScreen();
        });
    }
})(window.jQuery, window.Cookies);
